import { Patient } from '../types/Patient';
import { apiService } from './apiService';


const PatientService = {
    createPatient: async (data: Patient, signal?: AbortSignal) => {
        try {
            
            const response = await apiService.post('/patients/', data, {
                signal, 
            });

            return response;

        } catch (error: any) {
            console.error("Error in createPatient:", error);

            return {
                message: error.message || "An error occurred while adding the patient.",
                error,
            };
        }
    },

    getAllPatients: async (signal?: AbortSignal, page = 1, limit = 100, search = "") => {
        try {
            let url = `/patients?page=${page}&limit=${limit}`;

            if (search) {
                url += `&search=${encodeURIComponent(search)}`;
            }

            const response = await apiService.get(url, { signal });
            return response;
        } catch (error: any) {
            console.error("Error in get patients:", error);
            return {
                message: error.message || "An error occurred while getting the patients.",
                error,
            };
        }
    },

    updatePatient: async (patientId: string, updateData: any, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.patch(`/patients/${patientId}`, updateData, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in updatePatient:", error);

            return {
                message: error.message || "An error occurred while updating the patient.",
                error,
            };
        }
    },

    deletePatient: async (patientId: string, signal?: AbortSignal) => {
        try {
            const token = sessionStorage.getItem('token') ?? '';
            
            const response = await apiService.delete(`/patients/${patientId}`, {
                headers: {
                    //'Authorization': `Bearer ${token}`
                },
                signal, 
            });

            return response;
        } catch (error: any) {
            console.error("Error in deletePatient:", error);

            return {
                message: error.message || "An error occurred while deleting the patient.",
                error,
            };
        }
    },

};

export default PatientService;
